var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height justify-center"},[_c('div',{staticClass:"d-flex justify-center align-center"},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-text')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }